import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '../../dash/services/api.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  isAuthLoading$: Observable<boolean>;
  isAuthLoadingSubject: BehaviorSubject<boolean>;

  constructor(private http: HttpClient, private router: Router, private apiService: ApiService) {
    this.isAuthLoadingSubject = new BehaviorSubject<boolean>(false);
    this.isAuthLoading$ = this.isAuthLoadingSubject.asObservable();
  }

  login(data: any): Observable<any> {
    this.isAuthLoadingSubject.next(true);
    return this.http.post<any>(this.apiService.login, data).pipe(
      tap({
        next: (res: any) => { return res },
        error: (err: any) => err,
        finalize: () => this.isAuthLoadingSubject.next(false)
      })
    );
  }

  logout() {
    localStorage.removeItem('dash_data');
    this.router.navigate(['/auth/login']);
  }
}
